import { useQuery } from "@tanstack/react-query";
import GoogleFontsAPI from "../../api/GoogleFonts";
import { GOOGLE_FONTS } from "../../constants/QueryKeys";

const defaults = {
  enabled: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchOnMount: false,
  staleTime: Infinity,
};

export default function useGoogleFonts(settings = {}) {
  const data = useQuery({
    queryKey: [GOOGLE_FONTS, settings.sortBy, settings.category],
    queryFn: () => GoogleFontsAPI(settings.sortBy, settings.category),
    ...defaults,
    ...settings,
  });
  return data;
}
